// Estados de una conversación (portal_conversations.status).
// color/soft/border son tokens de diseño (cambian con el tema claro u oscuro).
import { Bot, Hourglass, UserCheck, CircleCheck } from 'lucide-react';

const tok = (k) => ({ color: `var(--st-${k})`, soft: `var(--st-${k}-soft)`, border: `var(--st-${k}-border)` });

export const STATUS = {
  bot:      { label: 'SARA',     icon: '🤖', Icon: Bot,         ...tok('bot') },
  queued:   { label: 'En cola',  icon: '⏳', Icon: Hourglass,   ...tok('queued') },
  assigned: { label: 'Asignada', icon: '👤', Icon: UserCheck,   ...tok('assigned') },
  closed:   { label: 'Cerrada',  icon: '✔', Icon: CircleCheck, ...tok('closed') },
};

export const ORIGIN = {
  sara_escalation: 'Escalada por SARA',
  template: 'Iniciada con plantilla',
  manual: 'Asignación manual',
};

export function statusInfo(status) {
  return STATUS[status] || STATUS.bot;
}
